export function memoize<TArgs extends any[], TReturn>(func: (...args: TArgs) => TReturn, resolver?: (...args: TArgs) => unknown): (...args: TArgs) => TReturn {
    const cache: Map<unknown, TReturn> = new Map();
    return function (this: any, ...args: TArgs) {
        const key = resolver ? resolver.apply(this, args) : args[0];
        if (!cache.has(key)) {
            cache.set(key, func.apply(this, args));
        }
        return cache.get(key) as TReturn;
    };
}
